/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Group_FailedInputs */

const en_doc_group_failed = /** @type {(inputs: Doc_Group_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const pt_br2_doc_group_failed = /** @type {(inputs: Doc_Group_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falhou`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Doc_Group_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_group_failed = /** @type {((inputs?: Doc_Group_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Group_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_group_failed(inputs)
	return pt_br2_doc_group_failed(inputs)
});